import { TagModel } from '@app/types/TagModel'
import { useClient, useQuery } from '@based/sdk/react'
import { useCallback, useMemo } from 'react'
import { TagSelectionGroup } from '../shared/TagSelectionGroup'
import { useEditContainerClose } from '../shared/useEditContainerClose'

export type InterestsEditProps = {
  initiativeId: number
  selectedTags: number[]
}

export const InterestsEdit = ({
  initiativeId,
  selectedTags,
}: InterestsEditProps) => {
  const closeFromContainer = useEditContainerClose()
  const onClose = closeFromContainer ?? undefined
  if (!onClose) {
    throw new Error(
      'InterestsEdit requires `onClose` or an `EditContainer` ancestor',
    )
  }

  const client = useClient()

  const interestsQuery = useQuery('list-user-interests')

  const allTags: TagModel<number>[] = useMemo(
    () =>
      (interestsQuery.data ?? []).map((i: { id: number; name: string }) => ({
        key: i.id,
        value: i.name,
      })),
    [interestsQuery.data],
  )

  const saveInterests = useCallback(
    (selectedIds: number[]): Promise<boolean> =>
      client.call('edit-initiative', {
        id: initiativeId,
        value: {
          interests: selectedIds.map((id) => ({ id })),
        },
      }),
    [client, initiativeId],
  )

  return (
    <TagSelectionGroup
      allTags={allTags}
      selectedIds={selectedTags}
      onClose={onClose}
      onSave={saveInterests}
    />
  )
}
